import { useRef, useState } from 'react';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';

import ApolloAuth from '../../services/apolloAuth';
import Notification from '../../components/Notification';
import Input from '../../components/Input';
import Button from '../../components/Button';
import LoginBackground from '../../assets/images/login-background.png';
import LogoSvg from '../../assets/svg/logo.svg';

import {
  Container,
  Image,
  BlueEllipse,
  FormContainer,
  Logo,
  Title,
  Description,
  BackLink,
} from './styles';

const ForgotPassword = () => {
  const formRef = useRef();
  const [isLoading, setLoading] = useState(false);
  const [isSent, setSent] = useState(false);

  async function handleFormSubmit({ email }) {
    formRef.current.setErrors({});

    if (!email) {
      formRef.current.setErrors({ email: 'Informe um email' });
      return;
    }

    try {
      setLoading(true);
      await ApolloAuth.forgotPassword({ email });

      // A Apolo responde igual para email existente ou não, para não revelar
      // quais contas existem — a tela precisa dizer o mesmo.
      setSent(true);
    } catch (err) {
      Notification({
        message:
          err.response?.data?.error || 'Não foi possível enviar o e-mail.',
        type: Notification.types.ERROR,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {isLoading && <div className="loader" />}
      <Container>
        <FormContainer>
          <Logo src={LogoSvg} alt="Logo" />

          {isSent ? (
            <>
              <Title>Verifique seu e-mail</Title>
              <Description>
                Se o e-mail informado estiver cadastrado, enviamos um link para
                você criar uma nova senha. O link expira em 1 hora.
              </Description>
            </>
          ) : (
            <>
              <Title>Recuperar senha</Title>
              <Description>
                Informe o e-mail da sua conta e enviaremos um link para você
                criar uma nova senha.
              </Description>
              <Form ref={formRef} onSubmit={handleFormSubmit}>
                <Input type="email" name="email" label="E-mail" />
                <Button primary text="Enviar link" type="submit" />
              </Form>
            </>
          )}

          <BackLink as={Link} to="/">
            Voltar para o login
          </BackLink>
        </FormContainer>
        <BlueEllipse />
        <Image src={LoginBackground} />
      </Container>
    </>
  );
};

export default ForgotPassword;
